/*!
  _   _  ___  ____  ___ ________  _   _      _    ___   _____ _____ __  __ ____  _        _  _____ _____ 
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | |    / \  |_ _| |_   _| ____|  \/  |  _ \| |      / \|_   _| ____|
 | |_| | | | | |_) || |  / / | | |  \| |   / _ \  | |    | | |  _| | |\/| | |_) | |     / _ \ | | |  _|  
 |  _  | |_| |  _ < | | / /| |_| | |\  |  / ___ \ | |    | | | |___| |  | |  __/| |___ / ___ \| | | |___ 
 |_| |_|\___/|_| \_\___/____\___/|_| \_| /_/   \_\___|   |_| |_____|_|  |_|_|   |_____/_/   \_\_| |_____|                                                                                                
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon AI Template - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/ai-template/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
	Button,
	Flex,
	Link,
	Icon,
	Image,
	Text,
	// Badge,
	useColorModeValue,
} from "@chakra-ui/react";
// Assets
import heroBg from "assets/img/hero/hero-bg.png";

// Custom components
import InnerContent from "layouts/innerContent";
import Associates from "sections/associates";

import dashboard from "assets/img/hero/dashboard-world-greatest-section.png";
import center from "assets/img/hero/floating-images.png";

import { MdChevronRight } from "react-icons/md";
import React from "react";

export default function Hero() {
	// Chakra Color Mode
	const textColor = useColorModeValue("#09090B", "white");
	const borderColor = useColorModeValue("gray.300", "white");
	return (
		<Flex
			w='100%'
			direction='column'
			pt={{
				base: "70px",
				md: "70px",
				lg: "80px",
				xl: "80px",
				"2xl": "110px",
				"3xl": "110px",
			}}
			justifyContent='center'
			alignItems='center'
			position='relative'>
			<Flex
				pt={{
					base: "40px",
					md: "80px",
					lg: "100px",
					xl: "100px",
					"2xl": "80px",
					"3xl": "100px",
				}}
				pb={{
					base: "40px",
					md: "40px",
					lg: "80px",
					xl: "100px",
					"2xl": "80px",
					"3xl": "80px",
				}}
				w='96vw'
				bgImage={heroBg}
				bgSize='cover'
				bgPosition='top'
				borderRadius={{ base: "20px", md: "50px" }}>
				<InnerContent
					w='1170px'
					maxW='100%'
					px={{ base: "20px", md: "40px", xl: "0px" }}
					zIndex='2'>
					{" "}
					<Flex
						maxW='100%'
						direction='column'
						width='stretch'
						justify='center'
						align='center'>
						{/* <Link href="#form">
              <Badge
                display="flex"
                alignItems="center"
                bg="#E3FEEB"
                borderRadius="25px"
                color="green.500"
                border="1px"
                borderColor="green.200"
                fontWeight="500"
                textTransform={"none"}
                letterSpacing="0px"
                fontSize={{ base: "xs", md: "sm" }}
                ps="14px"
                pe="10px"
                py="4px"
                mb="20px"
              >
                Up to
                <Text fontWeight="700" as="span" mx="2px">
                  $300 discount
                </Text>
                for the first 100 orders
                <Icon ms="4px" as={MdChevronRight} />
              </Badge>
            </Link> */}
						<Flex
							direction='column'
							mx='auto'
							mb={{ base: "50px", md: "70px" }}
							px={{ base: "0px", md: "0px", xl: "0px" }}
							maxW={{ base: "100%", lg: "100%", xl: "74%", "2xl": "82%" }}
							textAlign='center'>
							<Text
								as='h1'
								color={textColor}
								fontWeight='700'
								fontSize={{ base: "26px", md: "38px", lg: "44px", xl: "48px" }}
								lineHeight={{
									base: "36px",
									md: "56px",
									lg: "58px",
									xl: "58px",
								}}
								px={{
									base: "0px",
									md: "0px",
									lg: "40px",
									xl: "0px",
									"2xl": "60px",
								}}
								mb={{ base: "24px", md: "30px" }}>
								You know our products well. Now let’s work with them on your
								project.
							</Text>
							<Text
								mb={{ base: "30px", md: "40px" }}
								color='#52525B'
								alignSelf='center'
								fontSize={{ base: "sm", md: "md", xl: "md" }}
								lineHeight={{ base: "24px", md: "32px" }}
								letterSpacing='0px'
								fontWeight={"500"}
								w={{
									base: "94%",
									md: "90%",
									lg: "72%",
									xl: "96%",
									"2xl": "90%",
								}}>
								Discover the full capabilities of the Horizon UI products &
								library with our team of experts ready to support you in
								building, scaling, and customizing SaaS applications, e-commerce
								sites, and administrative dashboards.
							</Text>
							<Flex
								align='center'
								direction={{ base: "column", md: "row" }}
								justifyContent={{ base: "center", lg: "center" }}>
								<Link href='#form'>
									<Button
										variant='primaryGradient'
										py='20px'
										px='16px'
										fontSize='md'
										borderRadius='45px'
										me={{ base: "0px", md: "14px" }}
										mb={{ base: "20px", md: "0px" }}
										w={{ base: "300px", lg: "320px" }}
										h='70px'>
										Let’s discuss your Project
										<Icon
											as={MdChevronRight}
											w='16px'
											h='16px'
											mt='3px'
											ms='2px'
											color='white'
										/>
									</Button>
								</Link>
								<Link href='#projects'>
									<Button
										bg='transparent'
										variant='transparent'
										border='1px solid'
										borderColor={borderColor}
										color={textColor}
										my='auto'
										w={{ base: "300px", md: "200px" }}
										h='70px'
										fontSize='md'
										borderRadius='45px'>
										Explore Projects
									</Button>
								</Link>
							</Flex>
						</Flex>
						<Flex
							mb={{ base: "60px", md: "30px", lg: "50px", xl: "50px" }}
							position={"relative"}>
							<Image
								alt='react nextjs boilerplate dashboard template preview'
								zIndex={"2"}
								src={dashboard}
								maxH='max-content'
								w={{ base: "100%", lg: "100%", xl: "1360px" }}
							/>
							<Image
								alt='react nextjs boilerplate dashboard template technologies preview'
								// ms='-290px'
								top={{ base: "40%", md: "40%", lg: "40%", xl: "36%" }}
								transform='translate(0px, -50%)'
								right={{
									base: "-40px",
									md: "-70px",
									lg: "-100px",
									xl: "-70px",
								}}
								position='absolute'
								borderRadius={{ base: "4px", md: "10px" }}
								minW={{
									base: "400px",
									md: "800px",
									lg: "1100px",
									xl: "1299px",
								}}
								zIndex='2'
								src={center}
							/>
						</Flex>
						<Associates />
					</Flex>
				</InnerContent>
			</Flex>
		</Flex>
	);
}
